import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
} from "@redotech/redo-model/views/views";
import * as z from "zod";

export const getWorkOrdersCount = {
  name: "getWorkOrdersCount" as const,
  input: z.object({
    search: z.string().nullish(),
    filterGroup: FilterGroupSchema.nullish(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
  }),
  output: z.object({ total: z.number() }),
};
